import {
    defaultIdAttribute,
    defaultMergeStrategy,
    defaultProcessStrategy,
} from '/b2b/common/helpers/Normalizr';
import { entityName, idAttribute } from './DataStoreAgent.constants';

import { schema } from 'normalizr';

export { entityName, idAttribute } from './DataStoreAgent.constants';

export const mergeStrategy = defaultMergeStrategy(idAttribute);
export const processStrategy = defaultProcessStrategy(
    idAttribute,
    function (details, parent, parentKey) {
        if (parentKey !== null && parentKey === 'agent') {
            // Has a connection defined
            const { id = parent, connectionId = id } = parent;
            const currentConnections = details.connections || [];
            if (!currentConnections.includes(connectionId)) {
                details.connections = [...currentConnections, connectionId];
            }
        }
        return details;
    }
);

export default new schema.Entity(entityName, undefined, {
    idAttribute: defaultIdAttribute(idAttribute),
    mergeStrategy,
    processStrategy,
});
